import React, { useEffect, useRef, useState } from 'react';
import Request from '../../utils/Request';
import { api_version } from '../../settings';
import { listenFCMMessages } from '../../firebase/listenFCMMessages';
import { useHistory } from "react-router-dom";
import { responseValidate } from '../../utils/functions';
import { unlockNotificationSound } from '../../firebase/unlockNotificationSound';
import { formatDate } from '../../utils/functions';
import { setUnreadNotificationCount } from '../../store/reducers/App';
import { generateFCMToken } from '../../firebase/fcm';
import Store from '../../store';
import { connect } from 'react-redux';

const NotificationBell = ({unreadNotificationCount}) => {

    const [notifications, setNotifications] = useState([]);
    const [open, setOpen] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    const history = useHistory();

    const wrapperRef = useRef(null);

    useEffect(() => {
        const fcmToken = localStorage.getItem('fcm_token');
        if (!fcmToken) {
            void generateFCMToken();
        }
    }, []);

    useEffect(() => {

        const unlock = async () => {
            await unlockNotificationSound();
        };

        document.addEventListener("click", unlock, {
            once: true
        });

    }, []);

    /*
    |--------------------------------------------------------------------------
    | Fetch Notifications
    |--------------------------------------------------------------------------
    */

    useEffect(() => {
        fetchNotifications();
        const unsubscribe = listenFCMMessages(() => {
            fetchNotifications(true);
        });
        return () => {

            if (unsubscribe) {
                unsubscribe();
            }
        };

    }, []);

    useEffect(() => {

        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };

    }, []);

    /*
    |--------------------------------------------------------------------------
    | Fetch Notifications
    |--------------------------------------------------------------------------
    */

    const fetchNotifications = async (silent = false) => {

        try {

            const response = await Request.get(`${api_version}/notifications`,{
                params:{
                    notification_summary:true
                }
            });
            const result = responseValidate(response);
            const newNotifications = result.data || [];
            const newUnreadCount = newNotifications.unread_count || 0;

            if (silent && newUnreadCount > unreadNotificationCount) {
                setIsAnimating(true);
                setTimeout(() => {
                    setIsAnimating(false);
                }, 1000);

            }
            setNotifications(newNotifications?.result);
            Store.dispatch(setUnreadNotificationCount(newUnreadCount))

        } catch (error) {

            console.log('NOTIFICATION ERROR:', error);

        }
    };

    return (

        <>
            <div
                ref={wrapperRef}
                className="notification-bell-wrapper"
            >

                <button
                    className="notification-btn"
                    onClick={() => setOpen(!open)}
                >

                    <i
                        className={`fas fa-bell notification-icon ${
                            isAnimating ? 'animate' : ''
                        }`}
                    />

                    {unreadNotificationCount > 0 && (

                        <span className="notification-badge">
                            {unreadNotificationCount}
                        </span>

                    )}

                </button>

                {open && (

                    <div className="notification-dropdown">

                        <div className="notification-header">
                            Notifications
                         <button
                            onClick={() => {
                                setOpen(false);
                                history.push('/notifications'); 
                            }}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: '#01bf9d',
                                cursor: 'pointer',
                                fontSize: '13px',
                                fontWeight: '600',
                                justifyContent:'end'
                            }}
                        >
                            View All
                        </button>
                        </div>

                        <div className="notification-list">

                            {notifications?.length === 0 && (

                                <div className="notification-empty">
                                    No notifications found
                                </div>

                            )}

                            {notifications?.map((item) => (

                                <div
                                    key={item.id}
                                    className={`notification-item`}>

                                    <div className="notification-title">
                                        {item.title}
                                    </div>

                                    <div className="notification-body">
                                        {item.body}
                                    </div>

                                    <div className="notification-time">
                                        {
                                            formatDate(item.created_at)
                                        }
                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>

                )}

            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    unreadNotificationCount: state.App.unreadNotificationCount,
})

export default connect(mapStateToProps)(NotificationBell);